/**
 * Translations preloader — starts loading i18n translations as early as possible,
 * before React mounts. Skips loading when the widget is embedded in a parent
 * cashier on a status page (the parent already provides translations).
 */
import type { Location } from 'react-router-dom';
import { getInitialParams } from 'utils/getInitialParams';
import { hasParentWidgetAndIsOnStatusPage } from 'utils/locactionAndUrls';
import { loadLocizeTranslations } from 'utils/translations';

const shouldSkip = (): boolean => {
  try {
    const curLocation = window.self.location as unknown as Location;
    return hasParentWidgetAndIsOnStatusPage(curLocation);
  } catch {
    return false;
  }
};

if (!shouldSkip()) {
  const { lang, brand } = getInitialParams();
  loadLocizeTranslations(brand, lang);
}
